export default "/kiban/_next/static/images/07_1L_cupper_base_post-ee056c6f0c3934147fd7a87cdb2b72cc.png";